function imageOpenTab(evt, id) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("product-tabs-inner");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(id).style.display = "flex";
    evt.currentTarget.className += " active";
}

document.getElementById("defaultOpen").click();